export const getAcceptType = (method: string, urlGet: string) => {
  // Extraire les query params depuis l'URL (compatible navigateur)
  const queryString = urlGet.includes('?') ? urlGet.split('?')[1] : urlGet
  const params = new URLSearchParams(queryString)
  const itemsPerPage = params.get('itemsPerPage')
  const paginationRaw = params.get('pagination')
  // `params.get` renvoie une string : 'pagination=false' arrivait truthy et déclenchait
  // l'enveloppe paginée {items,total} au lieu d'un tableau plat (bug `dataX?.map is not a function`).
  // On normalise en booléen : 'false'/'0' -> false (tableau plat), absent -> null (tableau plat),
  // '1'/'true' -> true (enveloppe paginée).
  const pagination =
    paginationRaw === null ? null : paginationRaw !== 'false' && paginationRaw !== '0'

  return {
    itemsPerPage,
    pagination,
    Accept: method === 'GET' ? 'application/ld+json' : 'application/json',
  }
}
const parseJsonLdToJson = (data, itemsPerPage, pagination) => {
  if (data?.['@type'] === 'hydra:Collection' || data?.['@type'] === 'Collection') {
    const total = data['hydra:totalItems'] ?? data['totalItems']
    const items = data['hydra:member'] ?? data['member']
    if (!pagination) {
      return items
    } else {
      const lastPage = Math.ceil(total / Number(itemsPerPage)) || 1
      return {
        ...data,
        total,
        lastPage,
        count: items.length,
        items: items,
      }
    }
  } else {
    return data
  }
}

export default parseJsonLdToJson
